import React, { Component } from 'react'
import drAll from '../../../assets/images/icon/dr-all.png';
import drEnabled from '../../../assets/images/icon/dr-enabled.png';
import drDisabled from '../../../assets/images/icon/dr-disabled.png';
import drAllGray from '../../../assets/images/icon/dr-all-gray.png';
import drEnabledGray from '../../../assets/images/icon/dr-enabled-gray.png';
import drDisabledGray from '../../../assets/images/icon/dr-disabled-gray.png';
import { DR_BUTTON_TEXT } from '../model/drButtonType';
import styled from 'styled-components';



class DrButton extends Component {
  render() {
    const { text, onClick, isActive } = this.props;
    return (
      <Button 
        onClick={onClick} 
        isActive={isActive}
      >
        <img src={setIcon(isActive, text)} alt={text} />
        <span>{text}</span>
      </Button>
    );
  }
}

const Button = styled.button`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 0 24px;
  border: 1px solid var(--grey-300);
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
  border-radius: 6px;
  cursor: pointer;

  & > img {
    width: 38px;
    height: 38px;
  }

  ${({ isActive }) => isActive ? `
    background-color: white;
    color: rgba(25, 25, 25, 1);
  ` : `
    background-color: var(--grey-100);
    color: var(--grey-600);
  `}
`;

export default DrButton;

function setIcon(isActive, type) {
  if (isActive) {
    switch (type) {
      case DR_BUTTON_TEXT.ALL:
        return drAll;
      case DR_BUTTON_TEXT.ENABLED:
        return drEnabled;
      case DR_BUTTON_TEXT.DISABLED:
        return drDisabled;
      default:
        return drAll;
    }
  } else {
    switch (type) {
      case DR_BUTTON_TEXT.ALL:
        return drAllGray;
      case DR_BUTTON_TEXT.ENABLED:
        return drEnabledGray;
      case DR_BUTTON_TEXT.DISABLED:
        return drDisabledGray;
      default:
        return drAllGray;
    }
  }
}